<div class="modal-container-content">
  <span>
    Hieronder een overzicht van je telefoonhistorie. Je kunt per maand zien hoeveel gesprekken je hebt gevoerd,
    hoelang deze gesprekken geduurd hebben en welke kosten er aan verbonden zitten.
  </span>

  <ul>
    <li>
      <span>Telefoonnummer:</span>
      <span>{{ product.specs.voip_number | phone }}</span>
    </li>
    <li>
      <span>Type aansluiting:</span>
      <span>{{ product.specs.voip_product_description }}</span>
    </li>
  </ul>

  <app-dropdown
    icon="calendar"
    [items]="this.dropDownOptions()"
    [selected]="this.selected"
    (selectedChange)="this.selectionChanged($event)"
    [modal]="true"
    />

  @if (this.calls.length > 0) {
    <table class="calls">
      <thead>
        <tr>
          <th>Nummer</th>
          <th class="mobile-hidden">Datum & tijd</th>
          <th class="mobile-hidden">Duur</th>
          <th>Kosten ({{ this.isBusiness ? 'excl.' : 'incl.' }} BTW)</th>
        </tr>
      </thead>
      <tbody>
        @for (call of this.calls; track call) {
          <tr>
            <td>{{ call.to_number.toString() | phone }}</td>
            <td class="mobile-hidden">{{ call.datetime_start | date:'dd-MM-yyyy HH:mm:ss'}}</td>
            <td class="mobile-hidden">{{ call.duration_in_seconds | callDuration }}</td>
            <td>
              <app-currency [value]="this.isBusiness ? call.price_end_user : call.price_end_user * 1.21 "/>
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <app-divider/>
    <span>Geen geregistreerde gesprekken deze periode.</span>
  }

</div>
